import service from '../services';
import functions from '../utils/functions';
import notify from '../utils/notify';

/**
 * @param dadosConsultaPlaca {JSON} - objeto com os dados da consulta placa, idEmpresa, permitePlacaRepetida, propostaParaSomenteAgregado
 * @returns - objeto com dados da consulta
 */
export async function validaPlacaEmAberto(dadosConsultaPlaca) {
  if (dadosConsultaPlaca.propostaParaSomenteAgregado) return true;

  try {
    if (dadosConsultaPlaca.permitePlacaRepetida == false) {
      const res = await service.post(
        'CotacaoAberta',
        'validaPlaca',
        dadosConsultaPlaca,
      );
      if (res.data.codigoSituacao != 0) {
        const nomeConsultorPlaca = res.data.consultor;
        const regionalConsultorPlaca = res.data.regional;
        const modalPlacaRecusada = true;
        const codigoSituacao = res.data.codigoSituacao;
        const situacao = res.data.situacao;

        return {
          nomeConsultorPlaca,
          regionalConsultorPlaca,
          modalPlacaRecusada,
          codigoSituacao,
          situacao,
        };
      }
    }
  } catch (error) {
    throw new Error('Falha ao validar a placa, tente novamente');
  }
  return true;
}

/**
 * Pesquisa na base da bp por aquela placa ou chassi
 * @param {object} dadosConsulta
 * @returns {object}
 */
export async function buscarPlacaBaseBP(dadosConsulta) {
  try {
    const res = await service.post(
      'CotacaoAberta',
      'validaPlacaChassiBP',
      dadosConsulta,
    );

    const codigoSituacao = res.data.codigoSituacao;
    const situacao = res.data.situacao;
    const modalPlacaRecusada = codigoSituacao === '998' ? true : false;

    return Promise.resolve({
      modalPlacaRecusada,
      codigoSituacao,
      situacao,
    });
  } catch (error) {
    Promise.reject('Falha ao buscar a placa na base da BP');
  }
}

export function checkTipoPlaca(placa) {
  if (placa || typeof placa == 'string') {
    const _placa = placa.toLocaleUpperCase();
    let tipoPlaca;
    const padraoPlacaMercoSul =
      /([A-Z]{3})([-]{0,1})([0-9]{1}[A-J]{1}[1-9]{2})/g;
    const padraoPlacaBr = /([A-Z]{3})([-]{0,1})([0-9]{4})/g;

    const placaMercosul = padraoPlacaMercoSul.test(_placa);
    if (placaMercosul) {
      tipoPlaca = 'Mercosul';
      return tipoPlaca;
    }

    const placaBr = padraoPlacaBr.test(_placa);
    if (placaBr) {
      tipoPlaca = 'Placa Br';
      return tipoPlaca;
    }
  }

  this.$vs.notify({
    position: 'top-center',
    title: 'Atenção',
    text: 'A placa não é valida',
    color: 'danger',
  });

  return 'Placa invalida';
}

export function preparaPlacaParaConsulta(placa) {
  const arrayCaracteresPlaca = Array.from(placa.toUpperCase());
  const temHiffen = arrayCaracteresPlaca.includes('-');
  const objCaracteresPlaca = {
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D',
    4: 'E',
    5: 'F',
    6: 'G',
    7: 'H',
    8: 'I',
    9: 'J',
    A: 0,
    B: 1,
    C: 2,
    D: 3,
    E: 4,
    F: 5,
    G: 6,
    H: 7,
    I: 8,
    J: 9,
  };

  const indexCaracter = temHiffen ? 5 : 4;
  const caracterSubstiruicao = arrayCaracteresPlaca[indexCaracter];
  arrayCaracteresPlaca[indexCaracter] =
    objCaracteresPlaca[caracterSubstiruicao];
  const placaAlternativa = arrayCaracteresPlaca.join('');

  return [placa, placaAlternativa];
}

export async function consultaPlaca({
  tipoIdentificado,
  identificador,
  idEmpresa,
  somenteAgregado,
  permitePlacaRepetida,
}) {
  if (!identificador) {
    return;
  }

  if (identificador.length == 8 || identificador.length == 17) {
    try {
      let _identificador;

      if (tipoIdentificado == 'placa') {
        _identificador = preparaPlacaParaConsulta(identificador);
      } else {
        _identificador = identificador;
      }

      const dadosValidaPlaca = await validaPlacaEmAberto({
        tipoIdentificado,
        identificador: _identificador,
        idEmpresa,
        propostaParaSomenteAgregado: somenteAgregado,
        permitePlacaRepetida: permitePlacaRepetida,
      });

      return dadosValidaPlaca;
    } catch (error) {
      throw new Error(
        'Falha ao buscar placa, tente novamente a internet pode estar instavel',
      );
    }
  }
}


// SEGURADORA

/**
 * registra a proposta na fila de integração para ser eviada para o STAR
 * @param {object} object this.$vs
 * @param {number} idProposta da proposta
 */
export async function inserirFilaIntegracaoSTAR(object, idProposta) {
  try {
    object.loading();

    await service.post('Cotacao', 'inserir-fila-star', { idProposta });

    notify.notifySuccess(object, 'Proposta enviada para o STAR.');

    return true;
  } catch (error) {
    notify.notifyFail(object, error);
    return false;
  } finally {
    object.loading.close();
  }
}

/**
 * Calcula o valor da franquia da proposta
 * @param {*} proposta 
 * @returns 
 */
export function calcularFranquia(proposta) {
  const { dadosVeiculo, valorCotaParticipacao, produtos } = proposta;
  const { valorFipe } = dadosVeiculo;
  const produtosFranquiaEspecial = [1, 15];

  produtos.forEach((produto, index) => {
    const { id_produto,idProduto } = produto;
    const id = id_produto || idProduto

    if (produtosFranquiaEspecial.includes(id) ) {
      const novoValorFranquia = valorFipe * (valorCotaParticipacao / 100);
      produto.franquia = novoValorFranquia;
    }

    produtos[index] = produto;
  });

  proposta.produtos = produtos;

  return proposta;
}

